module.exports = __webpack_public_path__ + "static/media/banner-m.5c87b236.jpg";